<template>
  <div class="tree-table">
    <table>
<!--      <colgroup>-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--        <col style="width: 100px;">-->
<!--      </colgroup>-->
      <thead>
      <tr>
        <th style="width: 150px;">科目编码</th>
        <th style="width: 150px;">科目名称</th>
        <th style="width: 140px;">上年实际发生金额(元)</th>
        <th style="width: 130px;">本年预算金额(元)</th>
        <th style="width: 100px;">差额(元)</th>
        <th style="width: 100px;">差额百分比</th>
        <th style="width: 150px;">账目归属公司</th>
        <th style="width: 180px;">计算依据</th>
        <th style="width: 180px;">备注</th>
<!--        <th>操作</th>-->
      </tr>
      </thead>
      <tbody>
      <tree-row v-for="item in data" :key="item.id" :item="item" :subjectTypeId="subjectTypeId"></tree-row>
      </tbody>
      <tfoot>
      <tr>
        <td>合计</td>
        <td></td>
        <td style="text-align: right">{{preAnnualAmount}}</td>
        <td style="text-align: right">{{currentAnnualAmount}}</td>
        <td style="text-align: right">{{diff}}</td>
        <td style="text-align: right">{{diffPercent}}%</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import TreeRow from './TreeRow.vue';
import Decimal from "decimal.js";

export default {
  name: 'TreeTable',
  components: {
    TreeRow
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    subjectTypeId: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      preAnnualAmount: 0,
      currentAnnualAmount: 0,
      diff: 0,
      diffPercent: 0
    }
  },
  // created() {
  //   this.getSumNum()
  // },
  // mounted() {
  //   this.getSumNum()
  // },
  methods: {
    getSumNum() {
      this.preAnnualAmount = 0
      this.currentAnnualAmount = 0
      this.data.forEach(item => {
        this.preAnnualAmount = new Decimal(item.preAnnualPaidAmount).add(this.preAnnualAmount)
        this.currentAnnualAmount = new Decimal(item.currentAnnualBudgetAmount).add(this.currentAnnualAmount)
      })
      this.preAnnualAmount = new Decimal(this.preAnnualAmount).toFixed(2, Decimal.ROUND_HALF_UP)
      this.currentAnnualAmount = new Decimal(this.currentAnnualAmount).toFixed(2, Decimal.ROUND_HALF_UP)
      this.diff = new Decimal(this.currentAnnualAmount).sub(this.preAnnualAmount).toFixed(2, Decimal.ROUND_HALF_UP)
      this.diffPercent = new Decimal(this.preAnnualAmount).eq(0) ? 0 : new Decimal(this.diff).div(this.preAnnualAmount).mul(100).toFixed(2, Decimal.ROUND_HALF_UP)
    }
  }
};
</script>

<style scoped>
.tree-table {
  width: 100%;
  font-size: 12px;
  overflow-x: auto;
  margin: 20px 0;
  border-left: 1px solid gainsboro;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* 使表格宽度固定 */
}

th, td {
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}

th {
  border: 1px solid #ddd;
  background-color: #f4f4f4;
  text-align: center;
}

.child-rows table {
  width: 100%;
  table-layout: fixed;
}
</style>
